import React, { useState, useEffect } from "react";
import { Spin } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../../../utils/BasicAuthAPI";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import PieGraph from "../Graph/PieChart";

const DownTimePieGraph = (props) => {
  const [data, setData] = useState(null);
  const [loginError, setLoginError] = useState(false);

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const fetchDownTimeData = () => {
    liracrypt
      .get("/linedash/tabs/ld/tab/downtime", { lid: props.selectedLid })
      .then(({ data }) => {
        const fetchdata = data.data ? data.data : [];
        setData(fetchdata);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const config = {
    type: "pie",
    theme: "none",
    dataProvider: data,
    valueField: "Val",
    titleField: "Series",
    // "labelsEnabled": false,
    labelRadius: 2,
    pullOutRadius: 0,
    maxLabelWidth: 70,
    valueAxes: [
      {
        labelsEnabled: true,
        tickLength: 0,
        color: "#ffffff",
      },
    ],
    color: "#7f7f7f",
    labelTickColor: "#7f7f7f",

    colors: [
      "#FF6600",
      "#87CEEB",
      "#6495ED",
      "#4682B4",
      "#6A5ACD",
      "#04D215",
      "#0D8ECF",
      "#0D52D1",
      "#2A0CD0",
      "#8A0CCF",
      "#CD0D74",
      "#754DEB",
    ],
    // "labelText": "[[percents]]%",
    // "legend": {
    //     "position": "bottom",
    //     "marginBottom": 1,
    //     "autoMargins": false
    // },
    balloon: {
      fixedPosition: true,
    },
    export: {
      enabled: false,
    },
  };

  // const config = {
  //     "type": "serial",
  //     "backgroundColor": "#EFEFEF",
  //     "backgroundAlpha": 1,
  //     "addClassNames": true,
  //     "theme": "none",
  //     "autoMargins": false,
  //     "marginLeft": 110,
  //     "marginRight": 10,
  //     "marginTop": 10,
  //     "marginBottom": 70,
  //     "balloon": {
  //         "adjustBorderColor": false,
  //         "horizontalPadding": 10,
  //         "verticalPadding": 8,
  //         "color": "#ffffff"
  //     },

  //     "dataProvider": data,
  //     "valueAxes": [{
  //         "axisAlpha": 0,
  //         "position": "left"
  //     }],
  //     "startDuration": 1,
  //     "graphs": [{
  //         "lineAlpha": 0.6,
  //         "alphaField": "alpha",
  //         "fillColors": "#273C75",
  //         "lineColor": "#273C75",
  //         "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
  //         "fillAlphas": 1,
  //         "title": "Value",
  //         "type": "column",
  //         "valueField": "Val",
  //         "dashLengthField": "dashLengthColumn"
  //     }, {
  //         "id": "graph2",
  //         "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
  //         "bullet": "round",
  //         "lineThickness": 3,
  //         "bulletSize": 7,
  //         "bulletBorderAlpha": 1,
  //         "bulletColor": "#FFFFFF",
  //         "useLineColorForBulletBorder": true,
  //         "bulletBorderThickness": 3,
  //         "fillAlphas": 0,
  //         "lineAlpha": 1,
  //         "title": "Tgt",
  //         "valueField": "tgt",
  //         "dashLengthField": "dashLengthLine"
  //     }],
  //     "categoryField": "Series",
  //     "categoryAxis": {
  //         "gridPosition": "start",
  //         "axisAlpha": 0,
  //         "labelRotation": -45,
  //         "centerRotatedLabels": true,
  //         "tickLength": 0
  //     },
  //     "export": {
  //         "enabled": false
  //     },
  //     "rotate": true
  // };

  useEffect(() => {
    if (data === null) {
      fetchDownTimeData();
    }
  }, [data]);

  return (
    <>
      <SessionError visible={loginError} />
      <div>
        {data ? (
          <PieGraph data={data} divId={"downTimePieGraph"} />
        ) : (
          <div className="Loading">
            <Spin indicator={antIcon} tip="Loading..." />
          </div>
        )}
      </div>
    </>
  );
};

export default DownTimePieGraph;
